import Component from "flarum/common/Component";
import Avatar from "flarum/common/components/Avatar";
import classList from "flarum/common/utils/classList";

/**
 * One suggestion. `insert` is what replaces the typed fragment, `label` is what
 * the row shows — they differ for an emoji, where the row shows the glyph and the
 * insert is the shortcode.
 */

/**
 * The suggestion list above the composer.
 *
 * Deliberately presentational: which trigger opened it, what matched and how the
 * insertion is spliced into the textarea all live in ChatComposer, because they
 * depend on the caret. This only draws rows and reports clicks.
 */
export default class ChatAutocomplete extends Component {
  onupdate(vnode) {
    // `view()` returns null whenever there is nothing to suggest — which is most
    // of the time — and a component that rendered nothing has no `vnode.dom`.
    // Without this guard every redraw of the composer threw
    // "Cannot read properties of undefined (reading 'querySelector')".
    if (!vnode.dom) return;

    // Keep the keyboard-selected row in view when arrowing past the fold.
    const active = vnode.dom.querySelector(".ChatAutocomplete-item--active");
    active == null || active.scrollIntoView({
      block: "nearest"
    });
  }
  view() {
    const _this$attrs = this.attrs,
      suggestions = _this$attrs.suggestions,
      activeIndex = _this$attrs.activeIndex,
      onSelect = _this$attrs.onSelect,
      onHover = _this$attrs.onHover;
    if (suggestions.length === 0) return null;
    return m("div", {
      className: "ChatAutocomplete",
      role: "listbox"
    }, suggestions.map((suggestion, index) => m("button", {
      key: suggestion.key,
      type: "button",
      role: "option",
      "aria-selected": index === activeIndex,
      className: classList("ChatAutocomplete-item", {
        "ChatAutocomplete-item--active": index === activeIndex
      })
      // mousedown, not click: the textarea loses focus on mousedown and a
      // blur handler would have closed the list before click ever fired.
      ,
      onmousedown: e => {
        e.preventDefault();
        onSelect(suggestion);
      },
      onmouseenter: () => onHover(index)
    }, suggestion.user ? m(Avatar, {
      user: suggestion.user,
      className: "Avatar"
    }) : null, suggestion.emoji ? m("span", null, suggestion.emoji) : null, suggestion.icon ? m("i", {
      className: suggestion.icon,
      "aria-hidden": "true"
    }) : null, m("span", null, suggestion.label), suggestion.hint ? m("span", {
      className: "ChatAutocomplete-item-hint"
    }, suggestion.hint) : null)));
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ChatAutocomplete', ChatAutocomplete);